import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Injectable, Component, OnInit, ViewChild, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { serviceUrl } from '../common/serviceconstants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmitterService } from '../emitterservice';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-projectlist',
  templateUrl: './projectlist.component.html',
  styleUrls: ['./projectlist.component.scss']
})
@Injectable({
  providedIn: 'root'
})

export class ProjectlistComponent implements OnInit, AfterViewInit {
  element: any = [];
  formControl: AbstractControl;
  communityGoalOne = "";
  fundSource = "";
  department = "";
  division: "";
  agency: "";
  project: "";
  Amount: "";


  isadmin: any = false;
@Input() fyear= "Total";
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private httpClient: GenericHttpClient,
    private http: HttpClient,
    private dialog: MatDialog) {
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    }
    this.getProjectList();
  }

  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  FilterSource() {
    this.dataSource.filterPredicate = ((data, filter) => {
      const a = !filter.communityGoal || String(data.communityGoal).includes(filter.communityGoal)
      const b = !filter.fundSource || data.fundSource.toLowerCase().includes(filter.fundSource.toLowerCase());
      const c = !filter.department || data.department.toLowerCase().includes(filter.department.toLowerCase());
      const d = !filter.division || data.division.toLowerCase().includes(filter.division.toLowerCase());
      const e = !filter.agency || data.agency.toLowerCase().includes(filter.agency.toLowerCase());
      const f = !filter.project || data.project.toLowerCase().includes(filter.project.toLowerCase());
      const g = !filter.amount || ("$" + this.addCommas(data.amount)).toLowerCase().includes(filter.amount.toLowerCase());

      return a && b && c && d && e && f && g;

    }) as (PeriodicElement, string) => boolean;

    this.formControl = this.formBuilder.group({
      communityGoalOne: '',
      fundSource: '',
      department: '',
      division: '',
      agency: '',
      project: '',
      Amount: ''
    });

    this.formControl.valueChanges.subscribe(value => {
      if (value.Status === "All")
        value.Status = '';
      const filter = { ...value, name: value.ID } as string;
      this.dataSource.filter = filter;
    });


  }

  displayedColumns: string[] = [];


  ngOnInit() {

    this.displayedColumns = [

      'communityGoal',
      'fundSource',
      'department',
      'division',
      'agency',
      'project',
      'amount',


    ];
    this.FilterSource();
    EmitterService.get('cgoalidprojectlist').subscribe(data => {
      this.cgoalid = data.cid;
      this.deptid = data.did;
      this.getProjectList();
     });
     EmitterService.get('deptidprojectlist').subscribe(data => {
      this.cgoalid = data.cid;
      this.deptid = data.did;
      this.getProjectList();
     });
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }


  filterYear(data: any[]): any[] {
    return data.filter(p => p.fiscalYear ==this.fyear);
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */

  projectmessage: any = '';
  @Input() cgoalid='';
  @Input() deptid = '';
  getProjectList() {
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitInvestmentPivot', {CommunityGoalID:this.cgoalid,DepartmentID:this.deptid,ColFiscalYear:this.fyear}
    ).toPromise<any>().then(response => {
      //this.dataSource = new MatTableDataSource(response);
      if (response.length > 0) {
        this.projectmessage = '';

        // let item : any = [];
        // for (let i = 0; i < response.length; i++){
        // for(let j = 0; j < response[i].yearItems.length; j++){
        //   if(response[i].yearItems[j].fiscalYear = this.fyear){

        //   }
        // }

        //   if(response[i].amount != 0){

        //     item.push(response[i]);
        //   }
        // }
        this.dataSource.data = response;
        //console.log(response)
        
      } else {
        this.dataSource.data = response;
        this.projectmessage = "No Projects at this time. Please try again later."
      }
    });
  }



}